<template>
    <div class="story-maker-sticker story-maker-sticker-link">
        <img class="img-change-color" :src="require('@/assets/img/instagram/ehf.png')">
        <p class="text-finish">{{ $t('dash.post-creator.story.done') }}</p>
        <div class="sticker-link" :class="`style${stickerInstance.data.styleVariant}`">
           <div class="icon"></div>
            <p>{{ stickerInstance.data.text || stickerInstance.data.link }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            styleVariant: Number,
            setCbClick: Function,


            stickerInstance: {
                type: Object,
                required: true
            }
        },

        mounted () {
            if (this.setCbClick) this.setCbClick(this.stickerInstance.nextStyleVariant);
        }
    }
</script>
